<template>
  <div class="vehicle-models-section" role="region">
    <div class="section-wrapper">
      <div class="container">
        <div class="row">
          <div class="col-sm-12 model-column">
            <div class="models-wrapper">
              <div class="model-container" v-for="sedan in images.sedans" :key="sedan.modelName">
                <a href="#"
                  ><div class="model-text">
                    <h3 role="presentation">{{sedan.modelName}}</h3>
                    <span class="vehicles-count">19 available</span>
                  </div>
                  <img
                    :alt="sedan.modelName"
                    :src="sedan.sideView"
                /></a>
              </div>
              <div class="model-container" v-for="suv in images.suvs" :key="suv.modelName">
                <a href="#"
                  ><div class="model-text">
                    <h3 role="presentation">{{suv.modelName}}</h3>
                    <span class="vehicles-count">19 available</span>
                  </div>
                  <img
                    :alt="suv.modelName"
                    :src="suv.sideView"
                /></a>
              </div>
              <div class="model-container" v-for="truck in images.trucks" :key="truck.modelName">
                <a href="#"
                  ><div class="model-text">
                    <h3 role="presentation">{{truck.modelName}}</h3>
                    <span class="vehicles-count">19 available</span>
                  </div>
                  <img
                    :alt="truck.modelName"
                    :src="truck.sideView"
                /></a>
              </div>
              <div class="model-container">
                <a href="#"
                  ><div class="model-text">
                    <h3 role="presentation">Used Cars</h3>
                    <span class="vehicles-count">2043 available</span>
                  </div>
                  <img
                    alt="Used Cars"
                    :src="images.sedans[0].sideView"
                /></a>
              </div>
              <div class="model-container">
                <a href="#"
                  ><div class="model-text">
                    <h3 role="presentation">Certified Pre-Owned</h3>
                    <span class="vehicles-count">20 available</span>
                  </div>
                  <img
                    alt="Certified Pre-Owned"
                    :src="images.suvs[0].sideView"
                /></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: ['images'],
  mounted() {
    $("a.brand-link").removeAttr("href");
  },
};
</script>

<style
  scoped
  src="../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css"
></style>

<style scoped>
.vehicle-models-section {
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
}
.vehicle-models-section .section-wrapper {
  overflow-y: auto;
}
.vehicle-models-section .models-wrapper {
  position: relative;
  padding: 15px 0;
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: wrap;
  -moz-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  -moz-justify-content: center;
  justify-content: center;
}
.vehicle-models-section .models-wrapper .model-container {
  -webkit-box-flex: 0;
  -webkit-flex: 0 0 22%;
  -moz-box-flex: 0;
  -moz-flex: 0 0 22%;
  flex: 0 0 22%;
  -ms-flex: 0 0 22%;
  padding: 5px 10px;
  height: 31vh;
  max-width: 320px;
  max-height: 275px;
}
.vehicle-models-section .models-wrapper .model-container .model-text {
  letter-spacing: 0.159em;
  text-align: center;
}
.vehicle-models-section .model-text h3 {
  color: black;
  font-weight: 300;
  font-size: 18px;
}
.vehicle-models-section .vehicles-count {
  color: grey;
  font-weight: 500;
  font-size: 12px;
}
.vehicle-models-section .search-btns {
  padding: 5px;
  background: #f8f8f8;
  border-top: 1px solid #e1e1e1;
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: wrap;
  -moz-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  -moz-justify-content: center;
  justify-content: center;
}
.vehicle-models-section .search-btns .btn {
  margin-right: 5px;
  background-color: #23395d;
  color: #fff;
}
.model-container a:hover img {
  transform: scale(1.1);
  text-decoration: none;
}
.model-container a:hover img {
  color: #333;
  border-radius: 0;
  font-weight: 400;
  -moz-transition: all 300ms ease-out;
  -webkit-transition: all 300ms ease-out;
  -o-transition: all 300ms ease-out;
  transition: all 300ms ease-out;
}
.vehicle-models-section .models-wrapper .model-container img {
  max-height: 130px !important;
  max-width: 300px;
  width: auto !important;
  margin: 0 auto;
  display: block;
}
</style>
